import { Grid, SxProps, TextField, Theme } from '@mui/material';
import { useEffect } from 'react';
import { useController } from 'react-hook-form';

import { GridSizeType, gridSize } from '@/shared';

export type CustomTextFieldNoFormWithNameProps = {
  label: string;
  name: string;
  control: any;
  required?: boolean;
  type?: string;
  shrink?: boolean;
  disabled?: boolean;
  size?: GridSizeType;
  value?: string | number;
  defaultValue?: string | number;
  variant?: 'standard' | 'outlined' | 'filled';
  sxTextField?: SxProps<Theme>;
  startAdornment?: React.ReactNode;
  endAdornment?: React.ReactNode;
};

const CustomTextFieldNoFormWithName: React.FC<CustomTextFieldNoFormWithNameProps> = ({
  label,
  name,
  control,
  value,
  defaultValue,
  type = 'text',
  shrink = false,
  disabled = true,
  required = true,
  size = gridSize,
  variant = 'outlined',
  sxTextField,
  startAdornment,
  endAdornment,
}) => {
  const resolvedValue = value ?? defaultValue ?? '';

  const { field } = useController({
    name,
    control,
    defaultValue: resolvedValue,
  });

  useEffect(() => {
    if (field.value !== resolvedValue) {
      field.onChange(resolvedValue);
    }
  }, [resolvedValue, field]);

  return (
    <Grid item {...size}>
      <TextField
        fullWidth
        variant={variant}
        label={label}
        value={field.value ?? ''}
        required={required}
        InputLabelProps={{
          ...(shrink && { shrink: true }),
          ...(startAdornment && { startAdornment }),
        }}
        autoComplete='off'
        autoCorrect='off'
        type={type}
        inputProps={{ readOnly: disabled }}
        InputProps={{
          startAdornment: startAdornment ?? null,
          endAdornment: endAdornment ?? null,
        }}
        sx={{
          ...sxTextField,
          ...(disabled && { background: 'rgba(0, 0, 0, 0.04)' }),
        }}
      />
    </Grid>
  );
};

export default CustomTextFieldNoFormWithName;
